export default [
  {
    path: '/restricoes/novo',
    name: 'restrictions/novo',
    component: () => import(/* webpackChunkName: "restrictions" */ './Add.vue'),
    meta: { auth: true }
  },
  {
    path: '/restricoes/:id',
    name: 'restrictions/editar',
    component: () => import(/* webpackChunkName: "restrictions" */ './Edit.vue'),
    meta: { auth: true }
  }
]
